import axios from "axios";
export default axios.create({
  // baseURL: "https://api.hypertensionfoundationofindia.com/api/",
  baseURL: "https://hfi-api.bizobill.in/api/",
  // baseURL: "http://localhost:3003/api/",
});
